'use client';

import { useLoadAfterLcp } from '@repo/ui/useLoadAfterLcp';
import { FC } from 'react';

import { ChatInit } from './ChatInit';
import { ChatIntegration } from './ChatIntegration';

type Props = {
  license?: string;
};

export const Chat: FC<Props> = ({ license }) => {
  const ready = useLoadAfterLcp();

  if (!license || !ready) {
    return null;
  }

  return (
    <>
      <ChatInit license={license} />
      <ChatIntegration />
    </>
  );
};
